import { Outlet, useLocation, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { LoadingScreen } from "@/ui/components"
import { useIsAdmin } from "@/auth"

/**
 * Guard for the /admin subtree (product.md §9): the parent UserRoute has
 * already resolved authentication, so by the time this renders the roles
 * from the JWT are available. The admin redirects are colocated here —
 * non-admins are bounced to the workspace dashboard, and /admin has no
 * landing of its own, so it forwards to the evaluation queue.
 */
export default function AdminRoute() {
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const atIndex = pathname === "/admin" || pathname === "/admin/"

  useEffect(() => {
    if (!isAdmin) {
      void navigate({ to: "/dashboard", replace: true })
    } else if (atIndex) {
      void navigate({ to: "/admin/submissions", replace: true })
    }
  }, [isAdmin, atIndex, navigate])

  if (!isAdmin) {
    return <LoadingScreen />
  }

  return <Outlet />
}
